import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LayoutState = {
  hasScrollbar: boolean;
  clickedChipList: {
    id: string;
  };
  speedyRX: {
    isSpeedyRXActive: boolean;
    showSpeedyAlert: boolean;
    speedyExperience: boolean;
  };
};

const initialState: LayoutState = {
  hasScrollbar: false,
  clickedChipList: {
    id: '',
  },
  speedyRX: {
    isSpeedyRXActive: false,
    showSpeedyAlert: false,
    speedyExperience: false,
  },
};

const LayoutSlice = createSlice({
  name: 'layout',
  initialState: initialState,
  reducers: {
    setHasScrollbar: (state, { payload }: PayloadAction<boolean>) => {
      state.hasScrollbar = payload;
    },
    setClickedChipList: (state, { payload }: PayloadAction<{ id: string }>) => {
      state.clickedChipList = payload;
    },
    setSpeedyRXActive: (
      state,
      {
        payload,
      }: PayloadAction<{
        isActive: boolean;
        isFirstSetup: boolean;
        speedyExperience: boolean;
      }>
    ) => {
      if (payload.isFirstSetup) {
        state.speedyRX.speedyExperience = payload.speedyExperience;
        window.rxcBrain.setShowSpeedyInReview(
          payload.speedyExperience && payload.isActive
        );
      }
      if (
        state.speedyRX.isSpeedyRXActive !== payload.isActive &&
        !payload.isFirstSetup
      )
        window.rxcBrain.setSpeedyRXStatus(payload.isActive);

      if (state.speedyRX.isSpeedyRXActive) {
        state.speedyRX.showSpeedyAlert = !payload.isActive;
      }
      state.speedyRX.isSpeedyRXActive = payload.isActive;
    },
    setShowSpeedyAlert: (state, { payload }: PayloadAction<boolean>) => {
      state.speedyRX.showSpeedyAlert = payload;
    },
  },
});

export const layoutReducer = LayoutSlice.reducer;
export const layoutActions = LayoutSlice.actions;
